import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";

/**
 * Company details printed on invoices, refund invoices and credit memos.
 *
 * The read returns a complete block -- stored values where set, the previously
 * hardcoded ones where not -- so the settings form opens showing exactly what
 * the documents print today.
 */
export const CompanyProfileService = createApi({
  reducerPath: "CompanyProfile",
  baseQuery: RtkBaseQueryWithReauth(
    process.env.REACT_APP_BASE_URL || "http://localhost:8000"
  ),
  tagTypes: ["CompanyProfile"],
  endpoints: (builder) => ({
    getCompanyProfile: builder.query<any, void>({
      query: () => ({ url: "/company-profile", method: "GET" }),
      providesTags: ["CompanyProfile"],
    }),
    updateCompanyProfile: builder.mutation<any, Record<string, string>>({
      query: (body) => ({ url: "/company-profile", method: "PUT", body }),
      invalidatesTags: ["CompanyProfile"],
    }),

    /**
     * A sample invoice rendered with the values currently in the form, saved or
     * not. Returns a PDF, so the response is read as a blob rather than JSON.
     */
    previewInvoice: builder.mutation<Blob, { values: Record<string, string>; lang?: "en" | "de" }>({
      query: ({ values, lang = "en" }) => ({
        url: `/company-profile/preview?lang=${lang}`,
        method: "POST",
        body: values,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetCompanyProfileQuery,
  useUpdateCompanyProfileMutation,
  usePreviewInvoiceMutation,
} = CompanyProfileService;
